import { LBS_SHAFT_KEY, isLbsShaftKey } from '../SystemSummary/drawingRules'

/**
 * Group order of the KombiLine LBS basket. The shared `categoryOrder` knows only three of the LBS
 * keys, so the other groups would keep the order the lines come from the database in, which has no
 * ORDER BY and can change with a recalculation. The shaft comes first, then the inner pipe from the
 * mouth down with the Anschlussteil next to its T-Stück, as in KMMI's `ZUG_STACK_ORDER`, then the
 * Dichtungen and the Gleitmittel. The order is fixed, so it does not follow the drawing where that
 * moves the cleaning port. A key missing here, such as a future one, comes last.
 */
const LBS_BASKET_ORDER = [
  LBS_SHAFT_KEY,
  'rainHood',
  'rainHood:collar',
  'LengthElementService',
  'insulationPipes',
  'spacers',
  'TConnectorService',
  'removableConnection',
  'CleaningPortService',
  'FootingService',
  'condensateTray',
  'GasketService',
  'EquipmentService',
]

type Categorised = { category: string }

/**
 * The backend keys each shaft line by its classification (`KLBS:Schacht:coverPlates`), so the summary
 * drawing can place it. The basket keeps them under the one `KLBS:Schacht` heading.
 */
export function lbsBasketCategory(category: string) {
  return isLbsShaftKey(category) ? LBS_SHAFT_KEY : category
}

function rank(category: string) {
  const index = LBS_BASKET_ORDER.indexOf(category)
  return index === -1 ? LBS_BASKET_ORDER.length : index
}

/** Compares two basket groups, each holding the lines of one category. */
export function byLbsBasketOrder(a: Categorised[], b: Categorised[]) {
  return rank(a[0].category) - rank(b[0].category)
}
